import { LeftSquareFilled, RightSquareFilled } from '@ant-design/icons';
import { LinkButton } from '@lib/common';
import { Tooltip } from 'antd';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var PaginationContainer = styled.div.withConfig({
  displayName: "paginationcomponent__PaginationContainer",
  componentId: "sc-1wje8yt-0"
})([".ant-btn-icon-only.ant-btn-lg > *{font-size:32px;}position:fixed;bottom:5%;"]);
export var PaginationComponent = function PaginationComponent(props) {
  var onChangePagination = props.onChangePagination,
      options = props.options,
      previousButtonDisabled = props.previousButtonDisabled,
      nextButtonDisabled = props.nextButtonDisabled;
  return /*#__PURE__*/_jsxs(PaginationContainer, {
    children: [/*#__PURE__*/_jsx(Tooltip, {
      placement: "bottom",
      title: /*#__PURE__*/_jsx("span", {
        children: "Quay v\u1EC1 ph\u1EA7n tr\u01B0\u1EDBc"
      }),
      children: /*#__PURE__*/_jsx(LinkButton, {
        disabled: previousButtonDisabled,
        onClick: function onClick() {
          return onChangePagination(options.previous);
        },
        icon: /*#__PURE__*/_jsx(LeftSquareFilled, {})
      })
    }), /*#__PURE__*/_jsx(Tooltip, {
      placement: "bottom",
      title: /*#__PURE__*/_jsx("span", {
        children: "Ti\u1EBFn \u0111\u1EBFn ph\u1EA7n ti\u1EBFp theo"
      }),
      children: /*#__PURE__*/_jsx(LinkButton, {
        disabled: nextButtonDisabled,
        onClick: function onClick() {
          return onChangePagination(options.next);
        },
        icon: /*#__PURE__*/_jsx(RightSquareFilled, {})
      })
    })]
  });
};